import PostenLogo from './PostenLogo.js';
import HelthjemLogo from './Helthjem.js';
import PostnordLogo from './PostnordLogo.js';
import PostiLogo from './PostiLogo.js';
import DAOLogo from './DAOLogo.js';
import GLSLogo from './GLSLogo.js';
import Spinner from './Spinner.js';
import MatkahuoltoLogo from './MatkahuoltoLogo.js';

export {
    PostenLogo,
    HelthjemLogo,
    PostnordLogo,
    PostiLogo,
    DAOLogo,
    GLSLogo,
    Spinner,
    MatkahuoltoLogo,
};
